<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
      <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
    </div>
    <ng-container mCardHeaderTitle>
        <ng-template #modalContent let-close="close">


        <form #f1="ngForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="SaveCustomer(f1.form.valid)">
          <div class="modal-header">
            <h5 class="modal-title">{{ model.action }}</h5>
            <button type="button" class="close" (click)="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-body">
              <div class="form-group">
                <input type="hidden" id="idCustomer" name="idCustomer"
                  [(ngModel)]="model.idCustomer" value=0 #idCustomer="ngModel">
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="firstName">Full Name *</label>
                    <input type="text" id="customerFirstName" class="form-control border-primary" placeholder="Full Name"
                      [(ngModel)]="model.customerFirstName" name="customerFirstName" #customerFirstName="ngModel" required>
                    <small class="form-text text-muted danger" *ngIf="!customerFirstName.valid && f1.submitted">First
                      Name is required.</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="userinput1">GST No</label>
                    <input type="text" id="customerGSTNO" class="form-control border-primary" placeholder="GST No"
                      [(ngModel)]="model.customerGSTNO" name="customerGSTNO" #customerGSTNO="ngModel" >
                   
                  </div>
                </div>
               
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="userinput1">Email Id</label>
                    <input type="email" id="customerEmail" class="form-control border-primary" placeholder="Email Id"
                      [(ngModel)]="model.customerEmail" name="customerEmail" #customerEmail="ngModel">
                    
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="userinput1">Contact No </label>
                    <input type="text" id="customerContact" class="form-control border-primary" placeholder="Contact No"
                      [(ngModel)]="model.customerContact" name="customerContact" #customerContact="ngModel" >
                 
                  </div>
                </div>
             
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="userinput1">Address </label>
                    <input type="text" id="customerAddress" class="form-control border-primary" placeholder="Address"
                      [(ngModel)]="model.customerAddress" name="customerAddress" #customerAddress="ngModel" >
                   
                  </div>
                </div>
               
            
               
              </div>

            
            </div>


          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-outline-secondary">Save</button>
          </div>
        </form>

      </ng-template>

    </ng-container>
    <div class="content-body">
      <!-- <ngx-spinner bdColor = "rgba(0,0,0,0.5)" size = "medium" color = "#fff" type = "line-spin-fade" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner> -->
      <app-custom-loader-c></app-custom-loader-c>

    
      <section id="drag-area">

        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card [options]="options" (reloadFunction)="reloadProjectInfo($event)">

              <ng-container mCardBody>

                <form #f="ngForm"  (keydown.enter)="$event.stopPropagation()" (ngSubmit)="$event.stopPropagation()">

                  <div class="form-body">


                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="firstName">Select Customer  *</label>
                          <ng-select [items]="customerarray" style=" border: 1px solid #666ee8" [searchable]="true"
                            bindLabel="customerFullName" id="selectcustomer" placeholder="Select Customer"
                            [(ngModel)]="model.selectcustomer"
                            [virtualScroll]="true"
                            (change)="bindformcustomer(model.selectcustomer)" name="selectcustomer"
                            #selectcustomer="ngModel" required>
                          </ng-select>
                          <small class="form-text text-muted danger" *ngIf="!selectcustomer.valid && f.submitted">Please
                            select Customer.</small>
                            
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <a (keydown.enter)="$event.preventDefault()"  (click)="addcustomer()" class="btn btn-primary btn-sm gap_contact" style="margin-top: 6%;color:aliceblue"
                          >
                          <i class="d-md-none d-block feather ft-plus white"></i><span class="d-md-block d-none">Add
                            Customer</span></a>
                          </div>
                        </div>

                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="firstName"></label>                        
                        </div>
                      </div>
                     
                    </div>

                   

                    <ng-container *ngIf="showcustomer">
                      <div class="form-actions text-right">
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="div-custom-header" for="PatientInformation">Customer Information </label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="div-custom-label" for="FirstName">Full Name :</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="FirstName">{{customermodel.customerFirstName}}</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="div-custom-label" for="customerGSTNO">GST No:</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="customerGSTNO">{{customermodel.customerGSTNO}}</label>
                          </div>
                        </div>
                        

                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="div-custom-label" for="EmailId"><b>Email Id :</b></label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="EmailId">{{customermodel.customerEmail}}</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="div-custom-label" for="customerContact">Contact No:</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="customerContact">{{customermodel.customerContact}}</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="div-custom-label" for="customerAddress">Address:</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                           <p>{{customermodel.customerAddress}}</p>
                          </div>
                        </div>
                        
                      </div>


                      <div class="form-actions text-right">
                      </div>
                      <ng-container>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="div-custom-header" for="QuotationItems"><b>Quotation</b></label>

                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="quotationType"> Type *</label>
                              <select id="quotationType" class="form-control" style=" border: 1px solid #666ee8"
                                [(ngModel)]="model.quotationType" name="quotationType" #quotationType="ngModel"
                                required>
                                
                                <option value="Quotation">Quotation</option>
                                <option value="Pro Forma Invoice">Pro Forma Invoice</option>

                              </select>
                              <small class="form-text text-muted danger"
                              *ngIf="f.submitted && model.quotationType==undefined">Please
                              select Quotation Type.</small>

                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="quotationDate"> Date *</label>
                              <input type="date" class="form-control border-primary" [(ngModel)]="model.quotationDate"
                                name="quotationDate" #quotationDate="ngModel" [max]="maxdate" required />
                              <small class="form-text text-muted danger"
                                *ngIf="!quotationDate.valid && f.submitted">Please
                                Quotation Date.</small>



                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <input type="checkbox" [checked]='isEnabled' id="quotationGSTIsExcluded" [(ngModel)]="model.quotationGSTIsExcluded"
                                name="quotationGSTIsExcluded" #quotationGSTIsExcluded="ngModel" 
                                (click)="GstExcluded();" id="quotationGSTIsExcluded"/>
                              <label for="QuotationItems" style="margin-left: 7px;">GST Excluded</label>
                              
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">


                            </div>
                          </div>
                          <div class="col-md-2">

                          </div>
                        </div>

                        <div class="form-actions text-right">
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="div-custom-header" for="QuotationItems"><b>Quotation Items</b></label>

                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="row">
                            <div class="col-md-3">
                              <div class="form-group">
                                <label for="QuotationItem">Item *</label>                       
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="form-group">
                                <label for="quotationItems">HSN/SAC</label>
                               </div>
                            </div>
                            <div class="col-md-1">
                              <div class="form-group">
                                <label for="quotationItemGST">GST</label>
                              </div>
                            </div>
                            <div class="col-md-1">
                              <div class="form-group">
                                <label for="quotationItemQuantity">Qty</label>
                              </div>
                            </div>
                           
                            <div class="col-md-2">
                              <div class="form-group">
                                <label for="quotationItemRate"> Rate *</label>
      
                              </div>
                            </div>
                            
                            <div class="col-md-2">
                              <div class="form-group">
                                <label for="quotationAmmount">Amount </label>
                              
                              </div>
                            </div>


                          
                          </div>
                        </div>

                        <div *ngFor="let obj of quotationItems; let i=index">
                          <div *ngIf="obj.operationState !='d'" class="row">
                            <div class="col-md-3">
                              <div class="form-group">
                              <ng-autocomplete
                                [data]="lstitem"
                                [searchKeyword]="keyword"
                                placeholder="Item Name"
                                historyIdentifier="lstitem"
                                [itemTemplate]="itemTemplate"
                                [(ngModel)]="quotationItems[i].quotationItem"
                                 name="quotationItem{{i}}" 
                                 (keypress)="updateOperationState(i);"
                                 (change)="updateOperationState(i);"
                                (keyup.enter)="onScan(i)"  (keydown.tab)="onScan(i)"
                                (keydown)="$event.keyCode == 13 ? $event.preventDefault() : null"
                                [notFoundTemplate]="notFoundTemplate">
                              </ng-autocomplete>
                            
                              <ng-template #itemTemplate let-item>
                                <div class="item">
                                
                                  <span [innerHTML]="item"></span> 
                                 
                                </div>
                              </ng-template>
                            
                              <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                              </ng-template>

                                
                                <!-- <ng-autocomplete #quotationItem  [data]="lstitem" 
                                  [placeHolder]="placeholder" [searchKeyword]="keyword"
                                  [(ngModel)]="quotationItems[i].quotationItem" name="quotationItem{{i}}"   (keyup.enter)="onScan(i)"  (keydown.tab)="onScan(i)" notFoundText="Not found"
                                  [itemTemplate]="itemTemplateStatic" (keypress)="updateOperationState(i);" [notFoundTemplate]="notFoundTemplate" required>
                                </ng-autocomplete>

                                
                                <ng-template #itemTemplate let-item>
                                  <div class="item">
                                  
                                    <span [innerHTML]="item.quotationItem">></span> &nbsp; | &nbsp;
                                 
                                  </div>
                                </ng-template>

                                <ng-template #notFoundTemplate let-notFound>

                                </ng-template> -->
                              
                                <small class="form-text text-muted danger"
                                  *ngIf="f.submitted && (quotationItems[i].quotationItem=='' || quotationItems[i].quotationItem==undefined)">Please enter
                                  item name .</small>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="form-group">
                              
                                <input type="text" class="form-control border-primary"
                                  [(ngModel)]="quotationItems[i].quotationItemHSNSAC" placeholder="HSN/SAC"
                                  name="quotationItemHSNSAC{{i}}" (keypress)="updateOperationState(i);" #quotationItemHSNSAC="ngModel">

                              </div>
                            </div>
                            <div class="col-md-1">
                              <div class="form-group">
                           
                                <input type="number" class="form-control border-primary"
                                  [(ngModel)]="quotationItems[i].quotationItemGST" placeholder="GST" min=0
                                  name="quotationItemGST{{i}}" #quotationItemGST="ngModel" (keypress)="updateOperationState(i);" [disabled]="isgst" (change)="calculatetotal()" (keypress)="calculatetotal()">

                              </div>
                            </div>
                            <div class="col-md-1">
                              <div class="form-group">
                             
                                <input type="number" class="form-control border-primary" min=1
                                  [(ngModel)]="quotationItems[i].quotationItemQuantity" placeholder="Qty"
                                  name="quotationItemQuantity{{i}}" #quotationItemQuantity="ngModel" (keypress)="updateOperationState(i);"
                                  (change)="updateOperationState(i);" (change)="calculatetotal()" (keypress)="calculatetotal()">

                              </div>
                            </div>
                           
                            <div class="col-md-2">
                              <div class="form-group">
                            
                                <input type="number" class="form-control border-primary"  min=1
                                  [(ngModel)]="quotationItems[i].quotationItemRate" placeholder="Rate"
                                  name="quotationItemRate{{i}}" #quotationItemRate="ngModel" (keypress)="updateOperationState(i);"
                                  (change)="updateOperationState(i);" (change)="calculatetotal()" (keypress)="calculatetotal()" required>
      
                                  <small class="form-text text-muted danger"
                                  *ngIf="f.submitted && (quotationItems[i].quotationItemRate=='' || quotationItems[i].quotationItemRate==undefined)">Please enter
                                  rate.</small>
                              </div>
                            </div>
                            
                            <div class="col-md-2">
                              <div class="form-group">
                               
                                <input type="number" class="form-control border-primary" min=1
                                  [(ngModel)]="quotationItems[i].quotationAmmount" placeholder="Amount " (keypress)="updateOperationState(i);"
                                  (change)="updateOperationState(i);" name="quotationAmmount{{i}}" #quotationAmmount="ngModel"  (change)="calculateammounttotal(i)" >

                              </div>
                            </div>


                            <div class="col-md-1">
                              <div class="zommin form-group">
                               
                                <a   class="danger delete " >
                                  <i (click)="RemoveForm(i)" style="padding: 10%; font-size: 1.9rem;"  class="la la-trash-o"  
                                ></i>
                                </a>
                              </div>



                            </div>
                          </div>
                        </div>
                      
                          <div class="row">
                            <div class="col-md-2">
                            
                            </div>
                            <div class="col-md-3">
                              
                            </div>
                            <div class="col-md-2">
                           
                            </div>
                            <div class="col-md-2">
                            
                            </div>
                            <div class="col-md-2">
                             
                            </div>

                            <div class="col-md-1">
                              <div class="zommin form-group">
                                <a  >
                            
                                  <img  (click)="AddForm()" style="    padding-left: 10%;
                                  margin-top: -44%;" src="../../../../../assets/images/icons/plusicon.png">
                            
                                </a>
                              
                              </div>
                            </div>
                          </div>
                         
                        <div class="form-actions " style="margin-top: 40px;">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="quotationEnquiryContact">Enquiry Number </label>
                                <input type="text" class="form-control border-primary" 
                                  [(ngModel)]="model.quotationEnquiryContact" name="quotationEnquiryContact"
                                  #quotationEnquiryContact="ngModel" />

                              </div>
                            </div>
                          
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="totalAmount"> Total Amount  </label>
                                <input type="text" class="form-control border-primary" [ngModel]="model.totalAmount | number"
                                (ngModelChange)="model.totalAmount=$event"
                                  name="totalAmount" #totalAmount="ngModel"  readonly/>

                              </div>
                            </div>



                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label for="quotationTermCondition">Terms and Conditions </label>
                                <textarea class="form-control border-primary" style="height: 150px;"
                                  [(ngModel)]="model.quotationTermCondition" name="quotationTermCondition"
                                  #quotationTermCondition="ngModel" >
                                  </textarea>

                              </div>
                            </div>
                          </div>

                        </div>
                        <div class="form-actions text-right">

                          <button type="button" (click)="cancel()" class="btn btn-warning mr-1">
                            <i class="feather ft-x"></i> Cancel
                          </button>
                          <button type="submit"   (keydown.enter)="$event.stopPropagation()" (click)="savequotation(f.form.valid)" class="btn btn-primary">
                            <i class="la la-check"></i> Save
                          </button>

                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </form>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>